import { render } from "./ShareWallet.vue?vue&type=template&id=285c7cd5"
import script from "./ShareWallet.vue?vue&type=script&lang=js"
export * from "./ShareWallet.vue?vue&type=script&lang=js"

import "./ShareWallet.vue?vue&type=style&index=0&id=285c7cd5&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__